var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryCn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8829)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8829",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8829)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#F1361D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9104 2.76883L10.875 2.81001L11.1061 3.74742L11.4881 2.83057L12.4542 2.85414L11.7257 2.24632L12.0916 1.32347L11.2594 1.86467L10.5195 1.27075L10.7336 2.21305L9.9104 2.76883ZM11.7496 5.43823L12.6756 5.71157L12.673 6.67704L13.2655 5.87987L14.1971 6.13647L13.6373 5.37045L14.2157 4.56357L13.2772 4.88732L12.703 4.13203L12.6828 5.09814L11.7496 5.43823ZM13.3091 9.42018L12.5366 9.99925L12.8216 9.04777L12.0591 8.45417L13.0079 8.44518L13.3091 7.49925L13.6104 8.44518L14.5591 8.45417L13.7966 9.04777L14.0817 9.99925L13.3091 9.42018ZM10.1202 12.1428L11.0534 11.8953L11.5528 12.7216L11.645 11.7326L12.5743 11.4679L11.698 11.1042L11.773 10.1143L11.1393 10.8785L10.2563 10.5314L10.741 11.3674L10.1202 12.1428Z",
    fill: "#FFDC42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 8.22663L4.31561 9.90269L5.1831 7.14869L2.86252 5.43056L5.7498 5.40456L6.66675 2.66663L7.58369 5.40456L10.471 5.43056L8.1504 7.14869L9.01789 9.90269L6.66675 8.22663Z",
    fill: "#FFDC42"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8829"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryCn);
export default __webpack_public_path__ + "static/media/Country=CN.b16ed9929d1cc23ecacc6763b14bc771.svg";
export { ForwardRef as ReactComponent };